import * as React from 'react';
import {Query} from 'react-apollo';

import moment from 'moment';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {WarningIcon} from 'shells/icon/svg/warning-icon';
import {Link} from 'shells/link/link';
import {MessageContainer} from 'shells/message/message-container';
import {Body} from 'shells/typography/body';
import {Title} from 'shells/typography/title';

import type {GetEmailSyncStatusBanner as GetEmailSyncStatusBannerQuery} from 'nutshell-graphql-types';

import GET_EMAIL_BANNER_STATS_QUERY from './graphql/queries/get-email-sync-status-banner.graphql';

import styles from './sync-status-banner.module.css';

class EmailSyncStatusBannerQuery extends Query<GetEmailSyncStatusBannerQuery, Record<any, any>> {}

export function SyncStatusBanner() {
    return (
        <EmailSyncStatusBannerQuery query={GET_EMAIL_BANNER_STATS_QUERY}>
            {({data, loading}) => {
                const safeData = data || {};
                // @ts-expect-error
                const emailBannerStats = safeData.emailBannerStats || null;
                if (loading || !emailBannerStats) {
                    return null;
                }
                const isWarning = emailBannerStats.status === 'warning';

                let description = null;

                if (emailBannerStats.description) {
                    description = emailBannerStats.description;
                } else if (emailBannerStats.lastSyncTime && emailBannerStats.lastEmail) {
                    const lastSyncTime = emailBannerStats.lastSyncTime
                        ? moment.unix(emailBannerStats.lastSyncTime).fromNow()
                        : null;

                    description = (
                        <React.Fragment>
                            Last sync was {lastSyncTime}:{' '}
                            <Link href={emailBannerStats.lastEmail.htmlUrl} variant='primary'>
                                {emailBannerStats.lastEmail.subject}
                            </Link>
                        </React.Fragment>
                    );
                }

                const initialSyncDescription = emailBannerStats.initialSyncDescription;
                const initialSyncDescriptionIsError =
                    emailBannerStats.initialSyncDescriptionIsError;

                return (
                    <div className={styles.container}>
                        <MessageContainer>
                            <FlashBanner
                                animate={false}
                                type={isWarning ? 'warning' : 'info'}
                                hasBorder={true}
                            >
                                {isWarning ? (
                                    <div className='mr-16'>
                                        <WarningIcon size={32} />
                                    </div>
                                ) : undefined}
                                <div className={styles['text-container']}>
                                    <Title>{emailBannerStats.title}</Title>
                                    {initialSyncDescription ? (
                                        <Body as='div'>
                                            <span
                                                className={
                                                    initialSyncDescriptionIsError
                                                        ? styles.error
                                                        : ''
                                                }
                                            >
                                                {initialSyncDescription}
                                            </span>
                                        </Body>
                                    ) : undefined}
                                    {description &&
                                    (!initialSyncDescription || initialSyncDescriptionIsError) ? (
                                        <Body>{description}</Body>
                                    ) : undefined}
                                </div>
                                {emailBannerStats.error ? (
                                    <Link href='/my-account/email-syncing' variant='primary'>
                                        View details
                                    </Link>
                                ) : undefined}
                            </FlashBanner>
                        </MessageContainer>
                    </div>
                );
            }}
        </EmailSyncStatusBannerQuery>
    );
}
